import useAuthentication from '../hooks/useAuthentication';
import StoragePermissionDialog from '../components/dialogs/StoragePermissionDialog';
import PassKeyValidationModal, {
  PassKeyValidationType,
} from '../components/modals/PassKeyValidationModal';

const Auth = () => {
  const {
    userMetaData,
    appConfigs,
    isPassKeyModalOpen,
    isPermissionDialogOpen,
    onPassKeyValidation,
    validateStoragePermission,
    handleLogout,
  } = useAuthentication();

  const permissionView = () => (
    <>
      {isPassKeyModalOpen && userMetaData && appConfigs && (
        <PassKeyValidationModal
          appConfigs={appConfigs}
          userMetaData={userMetaData}
          onPassKeyValidation={onPassKeyValidation}
          validationType={PassKeyValidationType.Login}
          onLogout={handleLogout}
        />
      )}
      {isPermissionDialogOpen && appConfigs && (
        <StoragePermissionDialog
          validateStoragePermission={validateStoragePermission}
        />
      )}
    </>
  );

  return permissionView();
};

export default Auth;
